module.exports = __webpack_public_path__ + "img/branchempty.e77cf292.jpg";